// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__NUr7Y","title":"WelcomeBanner_title__zozsA","appEntry":"WelcomeBanner_appEntry__11QOd","appGrid":"WelcomeBanner_appGrid__zRwl5"};